import React from 'react';
import { Button, Icon, IconName } from '@economic/taco';
import { EcopediaFrameView } from '~/app/shared/components/Help/article/EcopediaFrameView';
import { useHelpDrawer } from '~/app/shared/components/Help/HelpDrawerContext';

export function LinkButton({
    icon,
    title,
    link,
    mode = 'embedded',
}: {
    title: React.JSX.Element | string;
    icon: IconName;
    link: string;
    mode: 'embedded' | 'external';
}) {
    const { navigate } = useHelpDrawer();

    return (
        <Button
            appearance="transparent"
            fluid
            className="!justify-start"
            onClick={event => {
                if (mode === 'embedded' && !event.ctrlKey && !event.metaKey) {
                    event?.preventDefault();
                    navigate(<EcopediaFrameView link={link} title={title} />);
                } else if (mode === 'external') {
                    window.open(link, '_blank');
                }
            }}>
            <Icon name={icon} />
            {title}
            {mode === 'embedded' ? <Icon name="chevron-right" className="!ml-auto" /> : null}
        </Button>
    );
}
